import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapActions } from 'vuex';
export default {
  name: 'app',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  created: function created() {
    this.i18nHandle(this.$i18n.locale);

    // 如果是范蠡大模型的网址
    // if(window.location.href.indexOf('guoyu-ai.rich-link.cn')!=-1){
    //   this.$router.replace('/FanLiIndex')
    // }
  },
  mounted: function mounted() {
    // 获取Token
    // this.refreshToken()
  },
  methods: _objectSpread({
    i18nHandle: function i18nHandle(val) {
      document.querySelector('html').setAttribute('lang', val);
    }
  }, mapActions('d2admin/account', ['refreshToken']))
};